import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage'
import LockboxPage from './pages/LockboxPage'
import ConnectPage from './pages/ConnectPage'
import '../src/styles/App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/app" element={
          <LockboxPage />
        } />
        <Route path="/connect" element={
          <ConnectPage />
        } />
        <Route path="/" element={
          <LandingPage />
        } />
      </Routes>
    </Router>
  );
}

export default App;
